<template>
  <HaveAQuestionComponent side="right" v-if="isMobile" class="have-a-question" />
  <HaveAQuestionComponent side="left" v-if="!isMobile" class="have-a-question" />
  <div class="summary-footer">
    <div class="footer-brand">
      <h1 class="footer-title">{{ trailerStore.selectedTrailer?.name }}</h1>
      <p class="footer-subtitle">{{ trailerStore.selectedTrailer?.trailer_group?.name }}</p>
    </div>

    <div class="summary-footer-right">
      <button class="summary-button" @click="toggleSaveConfig">
        <span class="button-text">Stwórz konfigurację</span>
      </button>
      <button class="summary-button" @click="toggleSummary">
        <span class="button-text">Podsumowanie</span>
      </button>
      <div class="price-summary">
        <h2 class="price-label">Łączna cena:</h2>
        <h1 class="price-value">
          {{ trailerStore.selectedTrailer ? totalPrice + ' zł' : '—' }}
        </h1>
      </div>
    </div>

    <teleport to="body">
      <transition name="fade">
        <SummaryComponent v-if="showSummary" @close="toggleSummary" @open-save-config="openSaveConfig" />
      </transition>
    </teleport>

    <teleport to="body">
      <transition name="fade">
        <SaveConfigComponent v-if="showSaveConfig" @close="toggleSaveConfig" />
      </transition>
    </teleport>
  </div>
</template>

<script>
import SummaryComponent from './SummaryComponent.vue';
import SaveConfigComponent from './SaveConfigComponent.vue';
import { useTrailerStore } from '@/stores/trailerStore'
import HaveAQuestionComponent from '../common/HaveAQuestionComponent.vue';

export default {
  name: 'SummaryFooterComponent',
  components: {
    SummaryComponent,
    SaveConfigComponent,
    HaveAQuestionComponent
  },
  data() {
    return {
      showSummary: false,
      showSaveConfig: false,
      isMobile: false
    };
  },
  computed: {
    trailerStore() {
      return useTrailerStore();
    },
    totalPrice() {
      const trailer = this.trailerStore.selectedTrailer;
      const trailerPrice = trailer ? trailer.price : 0;
      const addonsPrice = this.trailerStore.selectedTrailerAddonsPriceSum || 0;
      return this.trailerStore.formatPrice(trailerPrice + addonsPrice);
    }
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 1100;
    },
    toggleSummary() {
      this.showSummary = !this.showSummary;
    },
    toggleSaveConfig() {
      this.showSaveConfig = !this.showSaveConfig;
    },
    openSaveConfig() {
      this.showSaveConfig = true;
      this.showSummary = false;
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>


<style scoped lang="scss">
.summary-footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  z-index: 900;
  background-color: $color-background;
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 1px solid $color-grey;
  box-shadow: 0 -2px 10px $color-shadow;
  height: 80px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: auto;
    padding: 10px 16px;
    gap: 8px;
  }
}

.footer-brand {
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 100%;
    flex-direction: row;
    gap: 20px;
    align-items: first baseline;

    p {
      font-size: 1rem;
    }
  }
}

.footer-title {
  font-size: 1.5rem;
  color: $color-white;
  background-color: $color-primary-accent;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 5px 10px;
  margin: 0;
  margin-left: -10px;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    font-size: 1rem;
    margin: 0;
  }
}

.footer-subtitle {
  font-size: 0.95rem;
  color: $color-text-light;
  margin: 0;
  margin-top: 2px;

  @media screen and (max-width: 768px) {
    font-size: 0.65rem;
  }
}

.summary-footer-right {
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 768px) {
    gap: 20px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
}

.price-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 180px;

  @media screen and (max-width: 768px) {
    order: 0;
    align-items: first baseline;
    flex-direction: row;
    gap: 10px;
    width: 100%;
  }

  .price-label {
    font-size: 0.95rem;
    color: $color-text-light;
    margin: 0;
    margin-top: -5px;
    margin-bottom: 2px;
    font-weight: 500;

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }

  .price-value {
    font-size: 1.5rem;
    color: white;
    background-color: $color-primary-accent;
    border: 1px solid transparent;
    border-radius: 10px;
    padding: 5px 10px;
    margin: 0;
    font-weight: 600;

    @media screen and (max-width: 768px) {
      font-size: 1.3rem;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
}

.summary-button {
  display: flex;
  align-items: center;
  gap: 8px;
  outline: none;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  background-color: $color-primary;
  padding: 12px 24px;
  margin-bottom: -15px;
  color: $color-white;
  transition: all 0.3s ease;

  &:hover {
    background-color: $color-primary-dark;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.85rem;
    margin-bottom: 0px;
  }

  @media screen and (max-width: 768px) {
    order: 1;
    margin-bottom: 0px;
    width: 100%;
    justify-content: center;
    font-size: 0.85rem;
  }
}

.have-a-question {
  bottom: 70px;

  @media(max-width: 768px) {
    bottom: 160px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>